module.exports = __webpack_public_path__ + "static/img/cont61 (3).ef2f5c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61 (3).jpg
// module id = bMOF
// module chunks = 0